















import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({
  name: 'FleetAppFilterButton'
})
class FleetAppFilterButton extends Vue {
  @Prop({ type: String, default: '' })
  readonly isFleetApp!: string

  onFleetApp() {
    if(this.isFleetApp === 'FLEET_APPS') {
      this.$emit('fleet-app-change', '') 

      return
    }

    this.$emit('fleet-app-change', 'FLEET_APPS')
  }
}

export default FleetAppFilterButton
